/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const doubleDividerStyle = {
  dividerGray: {
    border: "1px solid",
    borderColor: "grey.500",
    marginBottom: "10px",
  },
  dividerPrimary: {
    border: "1px solid",
    borderColor: "primary.main",
    maxWidth: "66%",
    marginLeft: "auto",
    marginRight: "auto",
  },
};

export default doubleDividerStyle;
